import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from '../../../i18n/i18n';
import { toQuery, useQuery } from '../../Routes';
import './SortingChooser.css';
import { Icon, sort_arrows } from '../../Icon/Icon';
import { useEffect, useRef, useState } from 'react';

export const SortingChooser = ({ perma }: { perma: string }) => {
	const query = useQuery<{ sort: string }>();
	const { sort } = query;
	const [isOpen, setIsOpen] = useState(false);
	const [selectedSort, setSelectedSort] = useState(sort ?? '');
	const t = {
		...useTranslation().sort,
		...useTranslation().filtering,
	};
	const path = useLocation().pathname;
	const history = useHistory();
	const dropdownRef = useRef<HTMLDivElement | null>(null);
	const prevPermaRef = useRef<string>(perma);

	useEffect(() => {
		if (prevPermaRef.current !== perma) {
			setSelectedSort('');
		}

		prevPermaRef.current = perma;
	}, [perma]);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.removeEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	const toggleOpen = () => {
		setIsOpen(!isOpen);
	};

	const selectSort = (selectedValue: string) => {
		setSelectedSort(selectedValue);
		history.replace(path + '?' + toQuery({ ...query, sort: selectedValue || undefined }));
		setIsOpen(false);
	};

	const sortText = selectedSort ? t[selectedSort as keyof typeof t] : t.sort;

	return (
		<div className={`sorting-chooser ${isOpen ? 'open' : ''}`} onClick={toggleOpen} ref={dropdownRef}>
			<div className="sorting-button">
				<div className="sorting-content">
					<div className="sort-text">{sortText}</div>
					<div className="sort-icon">
						<Icon shape={sort_arrows} />
					</div>
				</div>
			</div>
			{isOpen && (
				<ul>
					<li className={selectedSort === '' ? 'selected' : ''} onClick={() => selectSort('')}>
						{t.popular}
					</li>
					<li className={selectedSort === 'aPrice' ? 'selected' : ''} onClick={() => selectSort('aPrice')}>
						{t.aPrice}
					</li>
					<li className={selectedSort === 'dPrice' ? 'selected' : ''} onClick={() => selectSort('dPrice')}>
						{t.dPrice}
					</li>
					<li className={selectedSort === 'aName' ? 'selected' : ''} onClick={() => selectSort('aName')}>
						{t.aName}
					</li>
					<li className={selectedSort === 'dEco' ? 'selected' : ''} onClick={() => selectSort('dEco')}>
						{t.dEco}
					</li>
				</ul>
			)}
		</div>
	);
};
